import { action } from 'mobx';
import PropTypes from 'prop-types';
import AsyncActionStore from '../AsyncActionStore';
import FlagStore from '../FlagStore';
import EntityStore from './EntityStore';

/**
 * Generic functionality of "edit modals" in Console
 */
export default class EntityFormStore extends EntityStore {
    static _PropType = {
        ...EntityStore._PropTypes,
        editModal: FlagStore.PropType.isRequired,
        exitConfirmationModal: FlagStore.PropType.isRequired,
        openEditModal: PropTypes.func.isRequired,
        closeEditModal: PropTypes.func.isRequired,
        load: PropTypes.func.isRequired,
        loadStatus: AsyncActionStore.PropType.isRequired,
        update: PropTypes.func.isRequired,
        updateStatus: AsyncActionStore.PropType.isRequired,
    };

    static PropType = PropTypes.shape(EntityFormStore._PropType);

    constructor(entityProps, ...otherProps) {
        super(entityProps, {
            editModal: new FlagStore(false),
            exitConfirmationModal: new FlagStore(false),
            loadStatus: new AsyncActionStore(),
            updateStatus: new AsyncActionStore(),
        }, ...otherProps);
    }

    openEditModal = action(() => {
        this.resetToOriginal();
        this.editModal.open();
    });

    closeEditModal = action(() => {
        if (this.exitConfirmationModal && this.hasChanged()) {
            this.exitConfirmationModal.open();
        } else {
            this.editModal.close();
        }
    });

    load = action(() => {
        if (!this.loadStatus.isLoading) {
            this.loadStatus.setLoading(this.apiLoad().then((resp) => {
                this.setValue(resp, true);
                return resp;
            }));
        }
        return this.loadStatus.promise;
    });

    update = action(() => {
        if (!this.updateStatus.isLoading) {
            this.updateStatus.setLoading(this.apiUpdate(this.getValue()))
                .then(action((resp) => {
                    this.editModal.close();
                    this.setValue(resp, true);
                }));
        }
        return this.updateStatus.promise;
    });
}
